import type { CartRecommendationItem } from '@diamond/shared/types';

/**
 * Comprehensive mock cart recommendation data for testing and development.
 *
 * Includes various scenarios:
 * - Products with different promo types (discount, bundled discount)
 * - Products with vouchers (count_voucher > 0)
 * - Products without promos
 * - Different tier classifications (strong_pair, category_pair, popular)
 * - Different recommendation sources (collaborative_filtering, content_based, trending)
 */
export const MOCK_RECOMMENDATIONS = [
  {
    product: {
      id: '6f1b9a1d-b3f1-42c9-8c70-000000000001',
      title: 'Elle Vire unsalted butter 200gr',
      desc: 'Elle Vire unsalted butter 200gr',
      type: 'ZTRD',
      pack_unit: '10X200 G',
      information: '',
      composition: '',
      superiority: '',
      item_code: 10001001,
      brand_name: 'ELLE & VIRE',
      brand_desc: 'ELLE & VIRE',
      division: 'trading',
      product_storage: 'chilled',
      barcode: '',
      measurement_unit: 'PC',
      measurement_unit_desc: 'Piece',
      sales_unit: 'Car',
      sales_unit_desc: 'Carton',
      dimension: '',
      dimension_unit: 'CM',
      gross_weight: 2,
      net_weight: 2,
      weight_unit: 'KG',
      gross_weight_desc: '2 KG',
      net_weight_desc: '2 KG',
      volume: 0,
      volume_unit: 'CCM',
      minimum_order_quantity: 1000,
      order_quantity_multiple: 1000,
      stock: 250000,
      stock_status: 'AVAILABLE',
      category_name: 'DAIRY',
      wishlist_id: null,
      sub_category_name: 'BUTTER',
      product_images: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_image_thumbnails: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_images_medium: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_images_large: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      prices: [{ price: 240100, min_order_quantity: 1000 }],
      stock_magnifier: 1000,
      free_good_promos: [],
      discount_promos: [],
      bundled_discount_promos: [],
      bundled_free_good_promos: [],
      count_voucher: 0,
    },
    recommendation: {
      id: '9a430d5e-2a34-4cb3-bc7f-000000000001',
      product_cart_ids: [],
      product_cart_item_codes: [],
      rank: 1,
      tier: 'strong_pair',
      display_context: 'cart_page',
      source: 'collaborative_filtering',
      is_weak_evidence: false,
      product_cart_count: 5,
      is_merged_recommendation: false,
    },
  },
  {
    product: {
      id: '6f1b9a1d-b3f1-42c9-8c70-000000000002',
      title: 'Edo mini puff pastry 375gr',
      desc: 'Edo mini puff pastry 375gr',
      type: 'ZTRD',
      pack_unit: '12X375 G',
      information: '',
      composition: '',
      superiority: '',
      item_code: 10001002,
      brand_name: 'EDO',
      brand_desc: 'EDO',
      division: 'trading',
      product_storage: 'frozen',
      barcode: '',
      measurement_unit: 'PC',
      measurement_unit_desc: 'Piece',
      sales_unit: 'Pac',
      sales_unit_desc: 'Pack',
      dimension: '',
      dimension_unit: 'CM',
      gross_weight: 4.5,
      net_weight: 4.5,
      weight_unit: 'KG',
      gross_weight_desc: '4.5 KG',
      net_weight_desc: '4.5 KG',
      volume: 0,
      volume_unit: 'CCM',
      minimum_order_quantity: 1000,
      order_quantity_multiple: 1000,
      stock: 180000,
      stock_status: 'AVAILABLE',
      category_name: 'BAKERY',
      wishlist_id: null,
      sub_category_name: 'PASTRY',
      product_images: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_image_thumbnails: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_images_medium: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_images_large: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      prices: [{ price: 33000, min_order_quantity: 1000 }],
      stock_magnifier: 1000,
      free_good_promos: [],
      discount_promos: [],
      bundled_discount_promos: [],
      bundled_free_good_promos: [],
      count_voucher: 2,
    },
    recommendation: {
      id: '9a430d5e-2a34-4cb3-bc7f-000000000002',
      product_cart_ids: [],
      product_cart_item_codes: [],
      rank: 2,
      tier: 'category_pair',
      display_context: 'cart_page',
      source: 'collaborative_filtering',
      is_weak_evidence: false,
      product_cart_count: 4,
      is_merged_recommendation: false,
    },
  },
  {
    product: {
      id: '6f1b9a1d-b3f1-42c9-8c70-000000000003',
      title: 'Oatside chocolate barista blend',
      desc: 'Oatside chocolate barista blend',
      type: 'ZTRD',
      pack_unit: '12X1 L',
      information: '',
      composition: '',
      superiority: '',
      item_code: 10001003,
      brand_name: 'OATSIDE',
      brand_desc: 'OATSIDE',
      division: 'trading',
      product_storage: 'dry',
      barcode: '',
      measurement_unit: 'PC',
      measurement_unit_desc: 'Piece',
      sales_unit: 'pcs',
      sales_unit_desc: 'Pieces',
      dimension: '',
      dimension_unit: 'CM',
      gross_weight: 12,
      net_weight: 12,
      weight_unit: 'KG',
      gross_weight_desc: '12 KG',
      net_weight_desc: '12 KG',
      volume: 0,
      volume_unit: 'CCM',
      minimum_order_quantity: 1000,
      order_quantity_multiple: 1000,
      stock: 120000,
      stock_status: 'AVAILABLE',
      category_name: 'BEVERAGES',
      wishlist_id: null,
      sub_category_name: 'ALTERNATIVE_MILK',
      product_images: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10001003_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10001003_2.jpg',
      ],
      product_image_thumbnails: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10001003_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10001003_2.jpg',
      ],
      product_images_medium: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10001003_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10001003_2.jpg',
      ],
      product_images_large: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10001003_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10001003_2.jpg',
      ],
      prices: [{ price: 33300, min_order_quantity: 1000 }],
      stock_magnifier: 1000,
      free_good_promos: [],
      discount_promos: [],
      bundled_discount_promos: [],
      bundled_free_good_promos: [],
      count_voucher: 0,
    },
    recommendation: {
      id: '9a430d5e-2a34-4cb3-bc7f-000000000003',
      product_cart_ids: [],
      product_cart_item_codes: [],
      rank: 3,
      tier: 'popular',
      display_context: 'cart_page',
      source: 'content_based',
      is_weak_evidence: false,
      product_cart_count: 3,
      is_merged_recommendation: false,
    },
  },
  {
    product: {
      id: '6f1b9a1d-b3f1-42c9-8c70-000000000004',
      title: '1883 Cucumber syrup 1 litre',
      desc: '1883 Cucumber syrup 1 litre',
      type: 'ZTRD',
      pack_unit: '6X1 L',
      information: '',
      composition: '',
      superiority: '',
      item_code: 10001004,
      brand_name: '1883',
      brand_desc: '1883',
      division: 'trading',
      product_storage: 'dry',
      barcode: '',
      measurement_unit: 'PC',
      measurement_unit_desc: 'Piece',
      sales_unit: 'Karton',
      sales_unit_desc: 'Karton',
      dimension: '',
      dimension_unit: 'CM',
      gross_weight: 6,
      net_weight: 6,
      weight_unit: 'KG',
      gross_weight_desc: '6 KG',
      net_weight_desc: '6 KG',
      volume: 0,
      volume_unit: 'CCM',
      minimum_order_quantity: 1000,
      order_quantity_multiple: 1000,
      stock: 80000,
      stock_status: 'AVAILABLE',
      category_name: 'BEVERAGES',
      wishlist_id: null,
      sub_category_name: 'SYRUP',
      product_images: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_image_thumbnails: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_images_medium: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_images_large: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      prices: [{ price: 240000, min_order_quantity: 1000 }],
      stock_magnifier: 1000,
      free_good_promos: [],
      discount_promos: [
        {
          id: '550e8400-e29b-41d4-a716-446655440101',
          mechanism: 'percentage',
          valid_from: Date.now(),
          valid_until: Date.now() + 86400000,
          promo_code: 'DISC10',
          calculation_number: 0,
          deduction_amount: 10,
          is_discount: true,
          minimum_order_quantity: 1000,
          minimum_order_amount: 0,
          price_after_discount: 216000,
          is_applies_in_multiples: false,
        },
      ],
      bundled_discount_promos: [],
      bundled_free_good_promos: [],
      count_voucher: 0,
    },
    recommendation: {
      id: '9a430d5e-2a34-4cb3-bc7f-000000000004',
      product_cart_ids: [],
      product_cart_item_codes: [],
      rank: 4,
      tier: 'strong_pair',
      display_context: 'cart_page',
      source: 'trending',
      is_weak_evidence: false,
      product_cart_count: 8,
      is_merged_recommendation: false,
    },
  },
  {
    product: {
      id: '6f1b9a1d-b3f1-42c9-8c70-000000000005',
      title: 'SW tomato diced with roasted garlic',
      desc: 'SW tomato diced with roasted garlic',
      type: 'ZTRD',
      pack_unit: '12X400 G',
      information: '',
      composition: '',
      superiority: '',
      item_code: 10001005,
      brand_name: 'SW',
      brand_desc: 'SW',
      division: 'trading',
      product_storage: 'dry',
      barcode: '',
      measurement_unit: 'PC',
      measurement_unit_desc: 'Piece',
      sales_unit: 'Bot',
      sales_unit_desc: 'Bottle',
      dimension: '',
      dimension_unit: 'CM',
      gross_weight: 4.8,
      net_weight: 4.8,
      weight_unit: 'KG',
      gross_weight_desc: '4.8 KG',
      net_weight_desc: '4.8 KG',
      volume: 0,
      volume_unit: 'CCM',
      minimum_order_quantity: 1000,
      order_quantity_multiple: 1000,
      stock: 150000,
      stock_status: 'AVAILABLE',
      category_name: 'FOOD',
      wishlist_id: null,
      sub_category_name: 'CANNED',
      product_images: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_image_thumbnails: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_images_medium: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_images_large: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      prices: [{ price: 210900, min_order_quantity: 1000 }],
      stock_magnifier: 1000,
      free_good_promos: [],
      discount_promos: [],
      bundled_discount_promos: [
        {
          id: '550e8400-e29b-41d4-a716-446655440201',
          mechanism: 'bundled_percentage',
          valid_from: Date.now(),
          valid_until: Date.now() + 86400000,
          promo_code: 'BUNDLE15',
          calculation_number: 0,
          deduction_amount: 15,
          is_discount: true,
          minimum_order_quantity: 2000,
          minimum_order_amount: 0,
          price_after_discount: 179265,
          is_applies_in_multiples: true,
          bundled_product_item_codes: [10001001, 10001005],
        },
      ],
      bundled_free_good_promos: [],
      count_voucher: 0,
    },
    recommendation: {
      id: '9a430d5e-2a34-4cb3-bc7f-000000000005',
      product_cart_ids: [],
      product_cart_item_codes: [],
      rank: 5,
      tier: 'category_pair',
      display_context: 'cart_page',
      source: 'content_based',
      is_weak_evidence: false,
      product_cart_count: 6,
      is_merged_recommendation: false,
    },
  },
  {
    product: {
      id: '6f1b9a1d-b3f1-42c9-8c70-000000000006',
      title: 'Wagyu beef ribeye',
      desc: 'Wagyu beef ribeye',
      type: 'ZTRD',
      pack_unit: '1 KG',
      information: '',
      composition: '',
      superiority: '',
      item_code: 10001006,
      brand_name: 'WAGYU',
      brand_desc: 'WAGYU',
      division: 'trading',
      product_storage: 'frozen',
      barcode: '',
      measurement_unit: 'PC',
      measurement_unit_desc: 'Piece',
      sales_unit: 'Car',
      sales_unit_desc: 'Carton',
      dimension: '',
      dimension_unit: 'CM',
      gross_weight: 1,
      net_weight: 1,
      weight_unit: 'KG',
      gross_weight_desc: '1 KG',
      net_weight_desc: '1 KG',
      volume: 0,
      volume_unit: 'CCM',
      minimum_order_quantity: 1000,
      order_quantity_multiple: 1000,
      stock: 50000,
      stock_status: 'AVAILABLE',
      category_name: 'MEAT',
      wishlist_id: null,
      sub_category_name: 'BEEF',
      product_images: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_image_thumbnails: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_images_medium: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_images_large: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      prices: [{ price: 72816, min_order_quantity: 1000 }],
      stock_magnifier: 1000,
      free_good_promos: [],
      discount_promos: [],
      bundled_discount_promos: [],
      bundled_free_good_promos: [],
      count_voucher: 1,
    },
    recommendation: {
      id: '9a430d5e-2a34-4cb3-bc7f-000000000006',
      product_cart_ids: [],
      product_cart_item_codes: [],
      rank: 6,
      tier: 'popular',
      display_context: 'cart_page',
      source: 'collaborative_filtering',
      is_weak_evidence: true,
      product_cart_count: 2,
      is_merged_recommendation: false,
    },
  },
  {
    product: {
      id: '6f1b9a1d-b3f1-42c9-8c70-000000000008',
      title: 'Biscoff spread 600gr',
      desc: 'Biscoff cookie butter spread 600gr',
      type: 'ZTRD',
      pack_unit: '12X600 G',
      information: '',
      composition: '',
      superiority: '',
      item_code: 10001008,
      brand_name: 'BISCOFF',
      brand_desc: 'BISCOFF',
      division: 'trading',
      product_storage: 'dry',
      barcode: '',
      measurement_unit: 'PC',
      measurement_unit_desc: 'Piece',
      sales_unit: 'Car',
      sales_unit_desc: 'Carton',
      dimension: '',
      dimension_unit: 'CM',
      gross_weight: 7.2,
      net_weight: 7.2,
      weight_unit: 'KG',
      gross_weight_desc: '7.2 KG',
      net_weight_desc: '7.2 KG',
      volume: 0,
      volume_unit: 'CCM',
      minimum_order_quantity: 1000,
      order_quantity_multiple: 1000,
      stock: 120000,
      stock_status: 'AVAILABLE',
      category_name: 'FOOD',
      wishlist_id: null,
      sub_category_name: 'SPREAD',
      product_images: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_image_thumbnails: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_images_medium: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_images_large: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      prices: [{ price: 72816, min_order_quantity: 1000 }],
      stock_magnifier: 1000,
      free_good_promos: [],
      discount_promos: [],
      bundled_discount_promos: [],
      bundled_free_good_promos: [],
      count_voucher: 0,
    },
    recommendation: {
      id: '9a430d5e-2a34-4cb3-bc7f-000000000008',
      product_cart_ids: [],
      product_cart_item_codes: [],
      rank: 8,
      tier: 'category_pair',
      display_context: 'cart_page',
      source: 'content_based',
      is_weak_evidence: false,
      product_cart_count: 4,
      is_merged_recommendation: false,
    },
  },
  {
    product: {
      id: '6f1b9a1d-b3f1-42c9-8c70-000000000009',
      title: 'Evian mineral water',
      desc: 'Evian natural mineral water 500ml',
      type: 'ZTRD',
      pack_unit: '24X500 ML',
      information: '',
      composition: '',
      superiority: '',
      item_code: 10001009,
      brand_name: 'EVIAN',
      brand_desc: 'EVIAN',
      division: 'trading',
      product_storage: 'dry',
      barcode: '',
      measurement_unit: 'PC',
      measurement_unit_desc: 'Piece',
      sales_unit: 'Car',
      sales_unit_desc: 'Carton',
      dimension: '',
      dimension_unit: 'CM',
      gross_weight: 12,
      net_weight: 12,
      weight_unit: 'KG',
      gross_weight_desc: '12 KG',
      net_weight_desc: '12 KG',
      volume: 0,
      volume_unit: 'CCM',
      minimum_order_quantity: 1000,
      order_quantity_multiple: 1000,
      stock: 300000,
      stock_status: 'AVAILABLE',
      category_name: 'BEVERAGES',
      wishlist_id: null,
      sub_category_name: 'WATER',
      product_images: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_image_thumbnails: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_images_medium: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_images_large: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      prices: [{ price: 72816, min_order_quantity: 1000 }],
      stock_magnifier: 1000,
      free_good_promos: [],
      discount_promos: [],
      bundled_discount_promos: [],
      bundled_free_good_promos: [],
      count_voucher: 0,
    },
    recommendation: {
      id: '9a430d5e-2a34-4cb3-bc7f-000000000009',
      product_cart_ids: [],
      product_cart_item_codes: [],
      rank: 9,
      tier: 'popular',
      display_context: 'cart_page',
      source: 'collaborative_filtering',
      is_weak_evidence: false,
      product_cart_count: 7,
      is_merged_recommendation: false,
    },
  },
  {
    product: {
      id: '6f1b9a1d-b3f1-42c9-8c70-000000000010',
      title: 'Diamond soft mix vanilla 500gr',
      desc: 'Diamond soft serve ice cream mix vanilla 500gr',
      type: 'ZFGD',
      pack_unit: '20X500 G',
      information: '',
      composition: '',
      superiority: '',
      item_code: 10001010,
      brand_name: 'DIAMOND',
      brand_desc: 'DIAMOND',
      division: 'diamond',
      product_storage: 'dry',
      barcode: '',
      measurement_unit: 'PC',
      measurement_unit_desc: 'Piece',
      sales_unit: 'Car',
      sales_unit_desc: 'Carton',
      dimension: '',
      dimension_unit: 'CM',
      gross_weight: 10,
      net_weight: 10,
      weight_unit: 'KG',
      gross_weight_desc: '10 KG',
      net_weight_desc: '10 KG',
      volume: 0,
      volume_unit: 'CCM',
      minimum_order_quantity: 1000,
      order_quantity_multiple: 1000,
      stock: 100000,
      stock_status: 'AVAILABLE',
      category_name: 'DAIRY',
      wishlist_id: null,
      sub_category_name: 'ICE_CREAM',
      product_images: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_image_thumbnails: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_images_medium: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      product_images_large: [
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_1.jpg',
        'https://diamond-file-uploads-staging.s3.ap-southeast-1.amazonaws.com/product-images/10000884_2.jpg',
      ],
      prices: [{ price: 72816, min_order_quantity: 1000 }],
      stock_magnifier: 1000,
      free_good_promos: [],
      discount_promos: [],
      bundled_discount_promos: [],
      bundled_free_good_promos: [],
      count_voucher: 1,
    },
    recommendation: {
      id: '9a430d5e-2a34-4cb3-bc7f-000000000010',
      product_cart_ids: [],
      product_cart_item_codes: [],
      rank: 10,
      tier: 'category_pair',
      display_context: 'cart_page',
      source: 'content_based',
      is_weak_evidence: false,
      product_cart_count: 5,
      is_merged_recommendation: false,
    },
  },
] as unknown as CartRecommendationItem[];
